import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { MessageCircleQuestion, X, Send, RotateCcw } from "lucide-react";
import { ChatThread } from "./ChatThread";
import { useAiChat } from "./useAiChat";

const HIDE = ["/ai-studio"];

export const AiChatWidget = () => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const chat = useAiChat({ storageKey: "buh_ai_sid", streamPath: "/ai/chat/stream", historyPath: "/ai/chat/history" });
  if (HIDE.includes(pathname)) { return null; }
  const compact = !open && pathname !== "/" && !pathname.startsWith("/shop");
  const submit = (e) => { e.preventDefault(); chat.send(text); setText(""); };

  return (
    <div className="fixed bottom-4 right-4 z-[60]" data-testid="ai-chat-widget">
      {open && (
        <div className="mb-3 w-[calc(100vw-2rem)] sm:w-96 h-[70vh] sm:h-[520px] flex flex-col rounded-2xl border border-gold/40 bg-[#06140f]/95 backdrop-blur-xl shadow-2xl overflow-hidden" data-testid="ai-chat-panel">
          <div className="flex items-center justify-between px-4 py-3 border-b border-gold/20 bg-[#0a2e22]">
            <div>
              <p className="font-serif text-sm font-semibold text-gold">Ask Bengal Umrah House</p>
              <p className="text-[11px] text-emerald-100/60">Packages, dates, payments & Umrah questions</p>
            </div>
            <div className="flex gap-1">
              <button onClick={chat.reset} title="New chat" data-testid="ai-chat-reset" className="p-1.5 rounded-md hover:bg-white/10 text-emerald-100/70"><RotateCcw className="w-4 h-4" /></button>
              <button onClick={() => setOpen(false)} data-testid="ai-chat-close" className="p-1.5 rounded-md hover:bg-white/10 text-emerald-100/70"><X className="w-4 h-4" /></button>
            </div>
          </div>
          <ChatThread messages={chat.messages} busy={chat.busy} testid="ai-chat-thread"
            empty="Assalamu Alaikum! Ask me anything about our Umrah packages, prices, dates or the Umrah steps — in Bengali, English or any language." />
          {chat.error && <p className="px-4 pb-1 text-xs text-red-300" data-testid="ai-chat-error">{chat.error}</p>}
          <form onSubmit={submit} className="flex gap-2 p-3 border-t border-gold/20">
            <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Type your question…" data-testid="ai-chat-input"
              className="flex-1 h-10 rounded-full bg-white/5 border border-gold/30 px-4 text-sm text-white placeholder:text-emerald-100/40 outline-none focus:border-gold" />
            <button type="submit" disabled={chat.busy || !text.trim()} data-testid="ai-chat-send" className="w-10 h-10 rounded-full bg-gold text-[#0a2e22] grid place-items-center disabled:opacity-50"><Send className="w-4 h-4" /></button>
          </form>
        </div>
      )}
      <button onClick={() => setOpen((o) => !o)} data-testid="ai-chat-toggle"
        className={`ml-auto flex items-center gap-2 rounded-full bg-gradient-to-r from-[#D4AF37] to-[#B8912A] text-[#0a2e22] font-semibold text-sm shadow-[0_10px_30px_rgba(212,175,55,0.35)] hover:-translate-y-0.5 transition-transform ${compact ? "w-11 h-11 justify-center opacity-90" : "pl-4 pr-5 h-12"}`}>
        {open ? <X className="w-5 h-5" /> : <MessageCircleQuestion className="w-5 h-5" />} {compact ? "" : open ? "Close" : "Ask us"}
      </button>
    </div>
  );
};
